<script setup lang="ts">
const { as = 'span', strokeWidth = '2px' } = defineProps<{
  as?: string;
  stroke: string;
  strokeWidth?: string;
  fill: string;
}>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <component
    :is="as"
    :style="{
      '--shadow-color': stroke,
      '--stroke-width': strokeWidth,
      color: fill,
    }"
    class="text-stroke"
  >
    <slot />
  </component>
</template>
